var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { ProcessStep, ImageUploader, CompletedStep } from 'Components.Structure';
var resolveImageTitle = function (count) {
    if (count === 0)
        return 'Upload Skipped';
    if (count === 1)
        return 'Image Uploaded';
    return 'Images Uploaded';
};
var resolveImageSubtitle = function (count) {
    if (count === 0)
        return 'No images uploaded';
    if (count === 1)
        return 'Image uploaded.';
    return "".concat(count, " images uploaded.");
};
var UploadImageProcessStep = /** @class */ (function (_super) {
    __extends(UploadImageProcessStep, _super);
    function UploadImageProcessStep(props) {
        var _this = _super.call(this, props) || this;
        _this.handleImageChange = function (files) {
            _this.setState({
                images: files,
            });
        };
        _this.handleEdit = function () {
            _this.setState({
                confirmed: false,
            });
            _this.props.onEdit();
        };
        _this.handleConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
            var images, _a, optional, onUpload, onConfirm, result, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        images = this.state.images;
                        _a = this.props, optional = _a.optional, onUpload = _a.onUpload, onConfirm = _a.onConfirm;
                        if (!optional && !images)
                            return [2 /*return*/];
                        this.setState({
                            loading: true,
                        });
                        if (!(images != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, onUpload({ images: images })];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _b = [];
                        _c.label = 3;
                    case 3:
                        result = _b;
                        if (result != null) {
                            this.setState({
                                loading: false,
                                confirmed: true,
                            });
                            onConfirm(result);
                        }
                        else {
                            this.setState({
                                loading: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            loading: false,
            confirmed: false,
            images: null,
        };
        return _this;
    }
    UploadImageProcessStep.prototype.render = function () {
        var _a = this.state, images = _a.images, loading = _a.loading, confirmed = _a.confirmed;
        var _b = this.props, optional = _b.optional, capture = _b.capture, multiple = _b.multiple, label = _b.label, subtitle = _b.subtitle;
        return (React.createElement(ProcessStep, { label: label, subtitle: subtitle, confirmed: confirmed, confirmDisabled: !optional && images == null, activeContent: (React.createElement(ImageUploader, { capture: capture, multiple: multiple, loading: loading, images: images, onChange: this.handleImageChange })), confirmedContent: (React.createElement(CompletedStep, { title: resolveImageTitle(images != null ? images.length : 0), subtitle: images != null
                    ? resolveImageSubtitle(images.length)
                    : undefined })), onConfirm: this.handleConfirm, onEditStep: this.handleEdit }));
    };
    UploadImageProcessStep.defaultProps = {
        capture: null,
        multiple: false,
        optional: false,
    };
    return UploadImageProcessStep;
}(React.Component));
export default UploadImageProcessStep;
